/**
 * Dashboard — Fiscal Periods Warning Banner
 *
 * Shown when the organisation has no fiscal periods configured.
 */

import { Button, Card } from '@elsapiens/ui'
import { Link } from 'react-router-dom'

export function FiscalPeriodsWarning(): JSX.Element {
  return (
    <Card className="el-mb-lg bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-400 dark:border-amber-600" padding="md">
      <div>
        <div className="flex items-start el-gap-md">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-amber-600 dark:text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                <path
                  clipRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  fillRule="evenodd"
                />
              </svg>
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-amber-900 dark:text-amber-100 el-mb-xs">
              Fiscal Periods Not Configured
            </h3>
            <p className="text-sm text-amber-800 dark:text-amber-200 el-mb-md">
              Your organization doesn&apos;t have any fiscal periods set up yet. Fiscal periods are required to post journal entries and organize your financial transactions. Configure them now to start using the full accounting features.
            </p>
            <Link to="/periods">
              <Button variant="primary">
                <svg className="w-4 h-4 el-mr-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
                </svg>
                Create Fiscal Periods
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Card>
  )
}
